<div class="page-container">
  <div class="page-header">
    <div>
      <h1 class="gradient-text">Журнал фотофіксації</h1>
      <p class="subtitle">Въїзди та виїзди із привязкою до розпізнаних номерних знаків</p>
    </div>
  </div>

  <mat-card>
    <mat-card-content>
      @if (loading) {
        <div class="loading-container">
          <mat-spinner></mat-spinner>
        </div>
      } @else {
        <table mat-table [dataSource]="photoLog" class="photo-log-table">
          <ng-container matColumnDef="timestamp">
            <th mat-header-cell *matHeaderCellDef>Дата та час</th>
            <td mat-cell *matCellDef="let entry">
              <div class="timestamp">
                <mat-icon>schedule</mat-icon>
                <div>
                  <strong>{{entry.timestamp | date:'HH:mm:ss'}}</strong>
                  <span>{{entry.timestamp | date:'dd.MM.yyyy'}}</span>
                </div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="licensePlate">
            <th mat-header-cell *matHeaderCellDef>Номерний знак</th>
            <td mat-cell *matCellDef="let entry">
              <div class="license-plate">
                {{entry.licensePlate}}
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="direction">
            <th mat-header-cell *matHeaderCellDef>Напрямок</th>
            <td mat-cell *matCellDef="let entry">
              <mat-chip [class]="getDirectionClass(entry.direction)">
                <mat-icon>{{getDirectionIcon(entry.direction)}}</mat-icon>
                {{getDirectionText(entry.direction)}}
              </mat-chip>
            </td>
          </ng-container>

          <ng-container matColumnDef="location">
            <th mat-header-cell *matHeaderCellDef>Місце</th>
            <td mat-cell *matCellDef="let entry">
              <div class="location">
                <mat-icon>place</mat-icon>
                {{entry.location}}
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="camera">
            <th mat-header-cell *matHeaderCellDef>Камера</th>
            <td mat-cell *matCellDef="let entry">
              <div class="camera">
                <mat-icon>videocam</mat-icon>
                {{entry.cameraId}}
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="confidence">
            <th mat-header-cell *matHeaderCellDef>Точність</th>
            <td mat-cell *matCellDef="let entry">
              <div class="confidence" [class.high]="entry.confidence >= 95" [class.medium]="entry.confidence >= 85 && entry.confidence < 95">
                <mat-icon>{{entry.confidence >= 95 ? 'check_circle' : 'info'}}</mat-icon>
                {{entry.confidence}}%
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Дії</th>
            <td mat-cell *matCellDef="let entry">
              <button mat-icon-button (click)="viewPhoto(entry)" matTooltip="Переглянути фото">
                <mat-icon>visibility</mat-icon>
              </button>
              <button mat-icon-button (click)="downloadPhoto(entry)" matTooltip="Завантажити">
                <mat-icon>download</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        @if (photoLog.length === 0) {
          <div class="empty-state">
            <mat-icon>photo_camera</mat-icon>
            <h3>Записів не знайдено</h3>
            <p>Фотофіксація в'їздів та виїздів відображатиметься тут</p>
          </div>
        }
      }
    </mat-card-content>
  </mat-card>
</div>
